import React from 'react';
import { Helmet } from "react-helmet";

const LiveSupport = () => {
    return (
        <>
            <Helmet>
                {/* GTM en <head> */}
                <script>
                    {`
            (function(w,d,s,l,i){w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-K32LWXGQ');
          `}
                </script>
            </Helmet>

            {/* GTM después del <body> (noscript) */}
            <noscript>
                <iframe
                    src="https://www.googletagmanager.com/ns.html?id=GTM-K32LWXGQ"
                    height="0"
                    width="0"
                    style={{ display: "none", visibility: "hidden" }}
                />
            </noscript>
            <div style={{ height: '100vh', margin: 0 }}>
                <iframe
                    src="https://direct.lc.chat/13071516/"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    title="Live Support"
                ></iframe>
            </div>
        </>
    );
};

export default LiveSupport;
